import classNames from "classnames";
import { usePrice } from "@hooks/use-prices";
import useFeatures from "@hooks/use-features";

const ProductPrice = ({ product, className }) => {
  const features = useFeatures();
  const price = usePrice();

  const priceDiff = product.retail_price - product.current_price;
  const calculatedDiscountPercent = Math.round((priceDiff / product.retail_price) * 100);
  const displayDiscountBadge = calculatedDiscountPercent > features.min_discount_to_display;

  return (
    <div className={classNames("d-flex align-items-center flex-start flex-wrap font-size-sm", className)}>
      <span className={classNames("font-weight-bold font-size-sm mb-0 me-1")}>
        {price(product.current_price, {withoutSpace: true})}
      </span>
      <span className="font-size-sm strike-price text-gray mb-0 me-1">
        {price(product.retail_price, {withoutSpace: true })}
      </span>
      <span className="font-size-sm text-gray mb-0">
        {displayDiscountBadge && (
          `(-${calculatedDiscountPercent}%)`
        )}
      </span>
    </div>
  );
};

export default ProductPrice;
